import * as React from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { postNotification } from "../../utils/Notifications";
import { postData } from "../../utils/APIUtilities";

export async function verifySignUp(verifyInfo, setProcessing, updateFormType) {
  const { username, verifyCode } = verifyInfo;

  if (!(username && verifyCode)) {
    postNotification("error", "Missing required fields");
    return;
  }

  setProcessing(true);

  try {
    await postData("/users/confirmsignup", {
      body: {
        email: username,
        verificationCode: verifyCode,
      },
    });
    postNotification("success", "Email Verified, you can now login");
    updateFormType("signIn");
  } catch (error) {
    postNotification("error", error, true);
  } finally {
    setProcessing(false);
  }
}

export async function resendVerifyCode(email = "") {
  if (typeof email != "string" || email.trim() === "") {
    postNotification("error", "Something went wrong");
    return;
  }

  try {
    await postData("/users/resendverification", {
      body: { email },
    });
    postNotification("info", "Please check your email for verification code");
  } catch (error) {
    postNotification("error", error, true);
  }
}
export default function CognitoVerifyForm({
  formState,
  updateFormState,
  updateFormType,
  setProcessing,
}) {
  const onSubmit = async (values) => {
    updateFormState(values);
    await verifySignUp(values, setProcessing, updateFormType);
  };

  return (
    <Formik
      initialValues={{
        username: formState?.username || formState?.email || null,
        verifyCode: formState?.verifyCode || null,
      }}
      enableReinitialize
      validationSchema={Yup.object().shape({
        username: Yup.string().nullable().max(128).required("Required"),
        verifyCode: Yup.string().nullable().max(255).required("Required"),
      })}
      onSubmit={onSubmit.bind(this)}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        setFieldTouched,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.username && errors.username)}
                helperText={touched.username && errors.username}
                autoComplete="username"
                name="username"
                value={values.username}
                label={"Email"}
                variant="outlined"
                required
                fullWidth
                onBlur={handleBlur}
                onChange={(e) => {
                  const trimmedString = e.target.value.trim().toLowerCase();
                  setFieldValue("username", trimmedString);
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.verifyCode && errors.verifyCode)}
                helperText={touched.verifyCode && errors.verifyCode}
                name="verifyCode"
                value={values.verifyCode}
                label="Verification Code"
                variant="outlined"
                required
                fullWidth
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <Button
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                onClick={async () => {
                  setFieldTouched("username");
                  if (Boolean(errors.username)) {
                    postNotification(
                      "error",
                      "Please enter a valid email to resend the code to"
                    );
                    return;
                  }
                  setProcessing(true);
                  await resendVerifyCode(values.username);
                  setProcessing(false);
                }}
              >
                Resend Code
              </Button>
            </Grid>

            <Grid item xs={12} md={6}>
              <Button type="submit" fullWidth variant="contained">
                Verify
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}
